<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  *ngIf="product.colors.length > 1"
  class="product-colors-container">
  <render-link
    class="product-colors-link"
    [lang]="lang"
    [link]="getProductLink(product.colors[0])">
    <div
      *ngFor="let color of visibleColors; trackBy: trackByColors"
      [title]="color.name"
      class="product-colors-badge">
      <img
        *ngIf="getColorImageData(color); let imageData"
        [lazySrc]="imageData"
        alt="{{ color.name }}"/>
    </div>
    <span
      *ngIf="remainingColors > 0"
      class="product-colors-counter"
      [attr.aria-label]="'Más ' + remainingColors + ' colores'"
      [title]="'Más ' + remainingColors + ' colores'">
      +{{ remainingColors }}
    </span>
  </render-link>
</div>
